import Rollbar from 'rollbar';

export function generateRollbarInstance(environment: string, ignoredMessages: string[], ignoredClasses: Set<string>) {
  return new Rollbar({
    accessToken: ROLLBAR_TOKEN,
    captureIp: `anonymize` as const,
    captureUncaught: true,
    captureUnhandledRejections: true,
    autoInstrument: {
      errorOnContentSecurityPolicy: true,
      log: false,
    },
    maxItems: 240,
    payload: {
      environment,
      client: {
        javascript: {
          source_map_enabled: true,
          guess_uncaught_frames: true,
          code_version: GIT_COMMIT,
        },
      },
      server: {
        root: `webpack://analytics/./`,
      },
    },
    uncaughtErrorLevel: `error` as const,
    ignoredMessages,
    checkIgnore(_isUncaught, _args, payload) {
      // @ts-ignore
      const trace = payload?.body?.trace;
      return !!(trace && trace.exception && ignoredClasses.has(trace.exception.class));
    },
    onSendCallback(_isUncaught, _args, payload) {
      // Mixpanel tracking for Rollbar errors (only for errors, not warnings or info)
      // @ts-ignore
      const {class: className, description, message} = payload.body.trace?.exception ?? {};

      if (environment === `production` && payload.level === `error`) {
        mixpanel.track(`Rollbar Error`, {
          uuid: payload.uuid,
          class: className,
          description,
          message,
        });
      }
    },
  } satisfies Rollbar.Configuration);
}
